import React from 'react'
import PropTypes from 'prop-types'
import * as styles from './styles'
import CustomLink from '../CustomLink/CustomLink'

const propTypes = {
  className: PropTypes.string,
}

const defaultProps = {
  className: '',
}

const HeroCodeSnippet = ({ className }) => {

  const queryExample = `{
  "from" : "invoices",
  "where" : {
    "Description": "AWS Cloud"
  },
  "predict" : "Processor",
  "limit": 1
}`

  const responseExample = `{
  "offset": 0,
  "total": 10,
  "hits": [
    {
      "$p": 0.9080951767188895,
      "Department": "IT",
      "Name": "Carol White",
      "Role": "IT Manager",
      "Superior": "Bob Brown"
    }
  ]
}`

  return (
    <styles.Container className={className}>
      <styles.CompactWrapper>
        <styles.CodeSection>
          <styles.CodeLabel>Query</styles.CodeLabel>
          <styles.CodeBlock>
            <pre>{queryExample}</pre>
          </styles.CodeBlock>
        </styles.CodeSection>

        <styles.ResponseSection>
          <styles.CodeLabel>Response</styles.CodeLabel>
          <styles.CompactResponseBlock>
            <pre>{`{
  "hits": [{
    "$p": 0.908,
    "Department": "IT",
    "Name": "Carol White"
  }]
}`}</pre>
          </styles.CompactResponseBlock>
        </styles.ResponseSection>
      </styles.CompactWrapper>
    </styles.Container>
  )
}

HeroCodeSnippet.propTypes = propTypes
HeroCodeSnippet.defaultProps = defaultProps

export default HeroCodeSnippet